import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { RecommendationGroupType } from "../../../../../components/pages/recommendations/components/off-hours-recommendations/utils/types/types";

export const getDailyOffHoursRecommendationsThunk = createAsyncThunk(
  "offHoursRecommendations/getDailyOffHoursRecommendations",
  async (
    {
      group,
      dismissed,
    }: {
      group: RecommendationGroupType;
      dismissed?: boolean;
    },
    { dispatch },
  ) => {
    const {
      getUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendations,
    } = cloudChiprApi.endpoints;

    return await dispatch(
      getUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendations.initiate(
        { group, isDismissed: dismissed },
        { forceRefetch: true },
      ),
    ).unwrap();
  },
);
